import { datadogRum } from "@datadog/browser-rum";
import Resource from "utils/resourcesUtil";
/**
 * @return {Promise}
 */
export function getPurchases(activeOnly) {
  const searchQuery = activeOnly ? `?filters=${encodeURI(JSON.stringify({active:true}))}` : '';
  return Resource.get(
    `purchase-service/api/v1/account/purchases${searchQuery}`,
  ).then(response => {
    return response.data;
  });
}

/**
 * @param {string} externalId
 * @return {Promise}
 */
export function getPurchaseByExternalId(externalId) {
  return Resource.get(
    `purchase-service/api/v1/account/purchases/externalId/${externalId}`
  ).then(result => {
    return result.data;
  });
}

/**
 * @param {string} externalId
 * @return {Promise}
 */
export function getLeftAmountToPay(externalId) {
  return new Promise(resolve => {
    Resource.get(
      `purchase-service/api/v1/account/purchases/${externalId}/payments/left-amount-to-pay`
    ).then(
      response => resolve(response.data),
      (/*error*/) => resolve({ leftAmountToPay: 0 })
    );
  });
}

/**
 * @param {string} externalId
 * @param {number} amount
 * @param {boolean} applyAmountToNextPayments
 * @return {Promise}
 */
export function simulateUnscheduledPayment(
  externalId,
  amount,
  applyAmountToNextPayments,
  requestCounter
) {
  const payload = {
    amount,
    applyAmountToNextPayments
  };
  return Resource.put(
    `purchase-service/api/v1/account/purchases/${externalId}/payments/simulate-pay-now-instead-of`,
    payload
  ).then(response => ({data: response.data, requestCounter}));
}

/**
 * @param {string} externalId
 * @param {number} amount
 * @param {boolean} applyAmountToNextPayments
 * @return {Promise}
 */
export function applyUnscheduledPayment(
  externalId,
  amount,
  applyAmountToNextPayments,
  debitCardDetails
) {
  const payload = {
    amount,
    applyAmountToNextPayments
  };
  if (debitCardDetails) {
    payload.detailedPaymentMethodDTO = {
      ...debitCardDetails.debitCardDetails,
      isCardWasSwiped: false,
      markAsNonePayment: false,
      sourceOfInput: 'MY_SUNBIT',
      paymentMethodType: 'DEBIT',
    }
  }
  return Resource.put(
    `purchase-service/api/v1/account/purchases/${externalId}/payments/pay-now-instead-of-debit`,
    payload
  ).then(response => response.data);
}

export function getDocumentForPurchase(externalId, notification, documentType) {
  const options = {
    params: {
      documentType
    }
  };

  return new Promise((resolve, reject) => {
    const path = `purchase-service/api/v1/account/${notification}/${externalId}/purchases/document`;
    Resource.get(path, options).then(
      response => {
        if (
          !response.data ||
          response.data === "" ||
          !response.data.content ||
          response.data.content === ""
        ) {
          reject(new Error("empty"));
        } else {
          resolve(response.data);
        }
      }, error => {
        datadogRum.addUserAction('Get document failed', { error, path, options });
        error => reject(error);
      }
    );
  });
}

/**
 * @param {string} externalId
 * @param {string} cardNumber
 * @param {string} expirationMonth
 * @param {string} expirationYear
 */
export function updatePurchaseDebitCard(
  externalId,
  cardNumber,
  expirationMonth,
  expirationYear,
  cvv
) {
  const payload = {
    cardNumber,
    expirationMonth,
    expirationYear,
    cvv
  };


  return Resource.putCard(
    `purchase-service/api/v1/account/purchases/${externalId}/debitcard`,
    payload
  ).then(response => response.data);
}

/**
 * @param {string} externalId
 * @param {number} [amount]
 */
export function payLate(externalId, amount = null) {
  const params = amount ? { amount } : null;
  const config = {
    params
  };

  return Resource.put(
    `purchase-service/api/v1/account/purchases/${externalId}/payments/manual-pay-debit`,
    null,
    config
  ).then(response => response.data);
}



// WEBPACK FOOTER //
// ./src/services/api/purchases.js